module.exports = __webpack_public_path__ + "img/Expo_TopicA4.2f48179a.png";